import { IWindowable } from "@multiweb/types/multiweb";
import { FormGroupContainer } from "UI/UI/DefaultInterface/FormGroupContainer";
import { WindowState } from "../UIManagerInterfaces";
import { IForm } from "../XGControls/IForm";
import { FormGroup } from "./FormGroup";
import { IFormGroup } from "./IFormGroup";
import { IOpenedForm } from "./IFormManager";

export class Homepage {
    private _homepageInfo: IOpenedForm;

    public get formGroup(): IFormGroup {
        return this._homepageInfo?.formGroup;
    }

    private _createOpenedFormInfo: (formGroup: IFormGroup, formInstanceId: string) => IOpenedForm | null;
    private _form: IWindowable | IForm | string;
    private _formGroupContainer: FormGroupContainer;
    private _formPlace: HTMLElement;

    private _isStarted: boolean = false;

    constructor(
        form: IWindowable | IForm | string,
        formGroupContainer: FormGroupContainer,
        formTarget: HTMLElement,
        _createOpenedFormInfo: (formGroup: IFormGroup, formInstanceId: string) => IOpenedForm | null) {
        this._createOpenedFormInfo = _createOpenedFormInfo;
        this._form = form;
        this._formGroupContainer = formGroupContainer;
        this._formPlace = formTarget;
    }

    public async show(): Promise<void> {
        if (!this._isStarted) {
            await this._init();
            this._formPlace.classList.add("homepage");

            this._isStarted = true;
        }

        this._homepageInfo.formGroup.show();
        if (this._homepageInfo.formGroup.currentModal == null) this._formPlace.classList.add("homepage");
    }

    /**
     * Skryje homepage
     * @param isFormAlreadyOpened Příznak, zda už byl před inicializací homepage, otevřený jiný formulář (např. z odkazu)
     */
    public hide(isFormAlreadyOpened: boolean = false): void {
        if (!this._isStarted && !isFormAlreadyOpened) {
            return;
        }
        this._homepageInfo?.formGroup.hide();
        this._formPlace.classList.remove("homepage");
    }

    /**
     * Inicializace homepage
     */
    private async _init(): Promise<void> {
        let fgroup: IFormGroup;

        if (typeof this._form === "string") {
            this._formGroupContainer.formName = this._form;
            fgroup = await FormGroup.initialize("", { formName: this._form, container: this._formGroupContainer });
        } else {
            if (this._form instanceof IForm) this._formGroupContainer.formName = this._form?.formName;
            fgroup = await FormGroup.initialize("", { form: this._form, container: this._formGroupContainer, setFormUI: true });
        }

        this._homepageInfo = this._createOpenedFormInfo(fgroup, "");

        this._homepageInfo.formGroup.formOpened.add((_s, _nfo) => {
            this._formPlace.classList.remove("homepage");
        });

        this._homepageInfo.formGroup.formClosed.add((_s, _nfo) => {
            this._formPlace.classList.add("homepage");
        });

        fgroup.form.setState(WindowState.closeDisabled, true);

        this._homepageInfo.formGroup.container.isHomePage = true;
    }
}
